//======================
//       Tabs
//======================
document.addEventListener('DOMContentLoaded', function() {
    let params = new URLSearchParams(window.location.search);

    for (var param of params.keys()) {
        if (param.startsWith("tabs-")) {
            var tabTrigger = document.querySelector('#' + param + '-tab-' + params.get(param))

            if (tabTrigger) {
                var tab = new bootstrap.Tab(tabTrigger)
                tab.show()
            }
        }
    }
});



jQuery(document).ready(function($) {

    $('.contactnowbtn').on( "click", function(e) {
        // e.preventDefault();
        if ($('section.contactform-display').length >= 1) {

            var formto = $(this).attr('data-email');
            // if (formto && $('section.contactform-display #contact_form_contact').length) {
            if (formto && !$('section.contactform-display #contact_form_recipient').val()) {
                formto = formto.replace(/\[([^\]]+)\]/, '<$1>');
                $('section.contactform-display #contact_form_recipient').val(formto);
            }
            $('section.contactform-display').removeClass('hidethis');
        }
    });

    $('#new-thinkers li').on( "click", function() {
           
            
            var acc = $(this).attr('data-acc');
            var rotated = $(this).attr('data-deg');

            var activePanel = $('.accordion-collapse.show:not(#'+acc+')');

            if ( (typeof  activePanel != undefined) && (activePanel.attr('id') != acc) ) {
                $('#new-thinkers li.active-view').removeClass('active-view');
                $(this).addClass('active-view');
               activePanel.collapse('hide');

               if (rotated) {
                   document.getElementById('new-thinkers').className = "rot"+rotated;
               }else{
                    document.getElementById('new-thinkers').className = "";
               }
                $('#'+acc).collapse('show');
            }

    } );


    $('.post-filter-container select').on( "change", function() {

                jQuery.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: "action=loadposts_call&postpage=" + $(this).attr('data-postpage') +"&category="+$('#post-category').val()+"&year="+$('#post-year').val(),
                    success: function(response) {
                         jQuery("#postlist-container").html(response);
                         lazyLoadInstance.update();
                    }
                });
    });


    $('#services-ans-select').on( "change", function() {
        $('#'+this.value).click();
    });


    setInterval(rotatethinker, 8000);

    function rotatethinker() { // #accordion-collapse-3
            var curr_el = $('#new-thinkers li.active-view').get(0);
            if (curr_el) {
            var parent = curr_el.parentElement;

            if (curr_el === parent.lastElementChild) {
              // if it's the last child, get the first
              nextLi = parent.firstElementChild;
              nextLi.click();
            } else {
              curr_el.nextElementSibling.click();
            }

            }

    }


    const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('bgmovenow');
        // Optional: unobserve if you only want it once
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 }); // trigger when 20% visible

  document.querySelectorAll('.ansprechpartner_bgmove').forEach((el) => observer.observe(el));


  const observer2 = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // if (entry.isIntersecting) {
      //   entry.target.classList.add('bgmovenow');
      //   // Optional: unobserve if you only want it once
      //   observer.unobserve(entry.target);
      // }
      if (entry.isIntersecting) {
          entry.target.classList.add('bgmovenow');
        } else {
          entry.target.classList.remove('bgmovenow');
        }
    });
  }, { threshold: 0.5 }); // trigger when 20% visible

  document.querySelectorAll('.homewaves').forEach((el) => observer2.observe(el));
  document.querySelectorAll('.homenumbers').forEach((el) => observer2.observe(el));


});